import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _15_HYDROLOGICAL_CYCLE:Partial<EcosystemServiceModel> ={
  id:'hydrological-cycle',
  pos:15,
  image: "/images/ecoservices/hydrological_cycle.jpg",
  code: ["2.2.1.3"],
  unit:'hydrological cycle',
  assetType:'other',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'benefitTransfer',
      name:"Benefit Transfer",
      unit: "m3",
      element: "water retention",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
